export enum TelematicsSelector {
  ALL = 'ALL',
  ALL_TELEMATIC_UNITS_EXCEPT_BEACONS = 'ALL_TELEMATIC_UNITS_EXCEPT_BEACONS',
  SELECTED = 'SELECTED',
}
